module.exports = __webpack_public_path__ + "assets/img/singularB.b49260f1.png";